import ClipperPlaceholder from './ClipperPlaceholder.jsx';

export default function OrdenesDeRetirosYServicios() {
  return (
    <ClipperPlaceholder title="Ordenes De Retiros & Servicios" category="Operativas" />
  );
}
